import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './App.css';
// Widgets
import Navbar from './components/widgets/Navbar';
import Footer from './components/widgets/Footer';
import CategoriesBanner from './components/widgets/CategoriesBanner'; 
// General 
import ArticlePage from './components/General/ArticlePage';
import NotFound from './components/General/NotFound';
import Contact from './components/General/Contact';
import Search from './components/General/search';
import About from './components/General/About';
import Donate from './components/General/Donate';

// English
import HomeEnglishNew from './components/English/HomeEnglishNew';
import CategoryArticles from './components/English/CategoryArticles';
import AllArticles from './components/English/AllArticles';

// Russian
import HomeRussian from './components/Russian/HomeRussian';
import RussianCategoryArticles from './components/Russian/RussianCategoryArticles';
import RussianAllArticles from './components/Russian/RussianAllArticles';

// Arabic
import HomeArabic from './components/Arabic/HomeArabic';
import ArabicAllArticles from './components/Arabic/ArabicAllArticles';
import ArabicCategoryArticles from './components/Arabic/ArabicCategoryArticles';
// Auth
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import Logout from './components/auth/Logout';
import PrivateRoute from './components/auth/PrivateRoute';
import GoogleLoginPagePopup from './components/auth/GoogleLoginPagePopup';
import AppleLoginPage from './components/auth/AppleLoginPage';
// SaaS
import Dashboard from './components/SaaS/Dashboard';
import Profile from './components/SaaS/Profile';
import Bookmarks from './components/SaaS/Bookmarks';
import StoriesPage from './components/SaaS/StoriesPage';
import StoryEditor from './components/SaaS/StoryEditor';
import UserArticlePage from './components/SaaS/UserArticlePage';
import AllUserPosts from './components/SaaS/AllUserPosts';
import ClipsPage from './components/SaaS/ClipsPage';
import ComediansPage from './components/SaaS/ComediansPage.js';
import ComedianDetailPage from './components/SaaS/ComedianDetailPage';
import ComediesPage from './components/SaaS/ComediesPage';
import ComedyMovieDetailPage from './components/SaaS/ComedyMovieDetailPage';

const App = () => {
    return (
        <Router> {/* Ensure Router wraps everything */}
            <AppContent />
        </Router>
    );
};

const AppContent = () => {
    const location = useLocation(); // Use useLocation to get the current path

    // fetch token from localStorage
    const token = localStorage.getItem('token');

    const isAuthenticated = Boolean(localStorage.getItem('authToken'));


    // Google Analytics: Track page view on route change
    useEffect(() => {
        window.gtag('event', 'page_view', {
            page_path: location.pathname,
        });
    }, [location]);

    // Determine the language from the current path
    let language = 'en'; // Default to English

    if (location.pathname.startsWith('/ru')) {
        language = 'ru'; // For Russian pages
    } else if (location.pathname.startsWith('/ar')) {
        language = 'ar'; // For Arabic pages
    }
    

    // Conditionally render CategoriesBanner based on path
    const showCategoriesBanner = !(
        location.pathname === '/login' || 
        location.pathname === '/register' || 
        location.pathname === '/dashboard' ||
        location.pathname === '/stories' ||
        location.pathname === '/create-story' ||
        location.pathname.startsWith('/story-editor') ||
        location.pathname === '/contact' || 
        location.pathname === '/logout' || 
        location.pathname === '/tasks' || 
        location.pathname === '/profile' ||
        location.pathname === '/clips' ||
        location.pathname === '/comedians' ||
        location.pathname.startsWith('/specials') ||
        location.pathname === '/comedies' ||
        location.pathname.startsWith('/comedies') ||
        location.pathname === '/about' ||
        location.pathname === '/donate' ||
        location.pathname === '/bookmarks' ||
        location.pathname.startsWith('/posts/')
    );

    return (
        <>
            <Navbar /> {/* Add the Navbar here !! */}
            {showCategoriesBanner && <CategoriesBanner language={language} />}
            <Routes>
                <Route path="/" element={<HomeEnglishNew />} />
                <Route path="/search/:query" element={<Search isAuthenticated={isAuthenticated} />} />
                <Route path="/posts/:slug" element={<ArticlePage />} /> {/* Route for individual article */}
                
                <Route path="/user-articles" element={<AllUserPosts />} />
                <Route path="/ru/category/:categoryId" element={<RussianCategoryArticles language="ru" />} />
                <Route path="/ar/category/:categoryId" element={<ArabicCategoryArticles language="ar" />} />
                <Route path="/category/:categoryId" element={<CategoryArticles language="en" />} />
                <Route path="/en/articles" element={<AllArticles />} />
                <Route path="*" element={<NotFound />} /> {/* Fallback route for 404 Page */}
                <Route path="/ru" element={<HomeRussian />} />
                <Route path="/ru/articles" element={<RussianAllArticles />} />
                <Route path="/ar/articles" element={<ArabicAllArticles />} />
                <Route path="/ar" element={<HomeArabic />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/about" element={<About />} />
                <Route path="/donate" element={<Donate />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/google-login" element={<GoogleLoginPagePopup />} />
                <Route path="/apple-login" element={<AppleLoginPage />} />
                <Route path="/user-posts/:slug" element={<UserArticlePage />} />
                
                <Route 
                    path="/dashboard" 
                    element={
                        <PrivateRoute>
                            <Dashboard />
                        </PrivateRoute>
                    } 
                /> 
                <Route 
                    path="/logout" 
                    element={
                        <PrivateRoute>
                            <Logout />
                        </PrivateRoute>
                    } 
                />
                <Route 
                    path="/profile" 
                    element={
                        <PrivateRoute>
                            <Profile />
                        </PrivateRoute>
                    } 
                /> 
                <Route 
                    path="/clips" 
                    element={
                        <PrivateRoute>
                            <ClipsPage />
                        </PrivateRoute>
                    } 
                />
                <Route 
                    path="/comedians" 
                    element={
                        <PrivateRoute>
                            <ComediansPage />
                        </PrivateRoute>
                    } 
                />
                <Route
                    path="/specials/comedians/:id"
                    element={
                        <PrivateRoute>
                            <ComedianDetailPage />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/comedies"
                    element={
                        <PrivateRoute>
                            <ComediesPage />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/comedies/:id"
                    element={
                        <PrivateRoute>
                            <ComedyMovieDetailPage />
                        </PrivateRoute>
                    }
                />
                <Route 
                    path="/bookmarks" 
                    element={
                        <PrivateRoute>
                            <Bookmarks />
                        </PrivateRoute>
                    } 
                />
                <Route 
                    path="/stories" 
                    element={
                        <PrivateRoute>
                            <StoriesPage />
                        </PrivateRoute>
                    } 
                />
                <Route
                    path="/create-story"
                    element={
                        <PrivateRoute>
                            <StoryEditor />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/story-editor/:slug?"
                    element={
                        <PrivateRoute>
                            <StoryEditor token={token} />
                        </PrivateRoute>
                    }
                />

            </Routes>
            <Footer />
        </>
    );
};

export default App;

